import { useApp } from '../provider/AppProvider'
import { useMemo } from 'react'

export const FLAGS = {
  SUPERUSER_COMMAND_PALETTE: 'superuser_command_palette',
  MULTI_TENANCY: 'multi_tenancy',
  TICKETS: 'tickets',
  TICKETS_CREATE: 'tickets_create',
  TICKETS_FEEDBACK: 'tickets_feedback',
  FLEX_PNI: 'flex_pni',
  WIZARD_SUCCESS_PAGE: 'wizard_success_page',
  FLEX_PEER: 'flex_peer',
  CUSTOMER_OPTIONAL: 'customer_optional',
  IP_TRANSIT_OVER_GRE: 'ip_transit_over_gre',
  FEEDBACK: 'feedback',
  USER_ANALYTICS: 'user_analytics',
  ASN_STATISTICS: 'asn_statistics',
  DDOS_PROTECTION: 'ddos_protection',
  SERVICE_ALERTS: 'service_alerts',
  WAVELENGTH: 'wavelength',
  SEPA_PAYMENTS: 'sepa_payments',
  DYNAMIC_PRODUCTS: 'dynamic_products',
  TWO_FACTOR_ENFORCEMENT: 'two_factor_enforcement',
  TWO_FACTOR_ENFORCEMENT_EVERYONE: 'two_factor_enforcement_everyone',
  TWO_FACTOR_AUTH: 'two_factor_auth',
  FLEX_INSIGHTS: 'flex_insights',
  GENERIC_SERVICE_DETAIL_PAGE: 'generic_service_detail_page',
  FLEX_TUNNEL_AS_VERIFICATION: 'flex_tunnel_as_verification',
  BENOCS: 'benocs',
  DASHBOARD_RESOURCES: 'dashboard_resources',
  NETWORK_FUNCTIONS_FIREWALL: 'network_functions_firewall',
  METRICS_EXTENDED: 'metrics_extended',
  DASHBOARD_V2: 'dashboard_v2',
  IDENTITY_PROVIDER: 'identity_provider',
  MODIFY_ORDERS_CDR: 'modify_orders_cdr',
  MODIFY_ORDERS_VLAN: 'modify_orders_vlan',
  INSIGHTS_DASHBOARD_FLOW_ANALYSIS: 'insights_dashboard_flow_analysis',
}

export const useFeatureFlag = (flag: string) => {
  const [appState] = useApp()

  return useMemo(
    () => appState.waffleFlags.includes(flag),
    [appState.waffleFlags, flag]
  )
}
